import React, { PropTypes } from 'react'

export default function Loader() {
  return (
    <div className="spinner" style={{marginTop:0}}>
      <div className="bounce1"/>
      <div className="bounce2"/>
      <div className="bounce3"/>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/app/components/loader.js